import * as React from "react";
import { useUserPrivilegeKeyPermissionsMap } from "../../hooks/use_backend";
import { formatRecentDate } from "../../scripts/utils";
import { useSiteData } from "../../hooks/use_site";
import InfoCard from "../general/info_card";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useReplaceSmartboxDialog } from "../dialogs/replace_smartbox_dialog";
import { hasPermission } from "../../pages/login/login_utils";
import Privilege from "../../enums/privilege_enum";

export default function ClientCard({ required_privilege, tooltip, ...props }) {
  const { data: siteData } = useSiteData();

  const openReplaceSmartboxDialog = useReplaceSmartboxDialog();

  const isOnline = siteData && siteData.online;
  const onlineSince = siteData && formatRecentDate(new Date(1000 * siteData.client_connected_at));
  const offlineSince =
    siteData && siteData.client_disconnected_at != null
      ? formatRecentDate(new Date(1000 * siteData.client_disconnected_at))
      : "start";

  const permissionMap = useUserPrivilegeKeyPermissionsMap();
  const canEdit = hasPermission(permissionMap, Privilege.CRM_CRM_OVERVIEW.getPrivilegeKey(), true);
  return (
    <InfoCard
      tooltip={tooltip}
      title={"Box Info"}
      {...props}
      content={[
        {
          key: "Box ID",
          value: siteData.box_id,
          buttonIcon: canEdit ? <SwapHorizIcon /> : null,
          onButtonClick: () => openReplaceSmartboxDialog(siteData),
        },
        {
          key: isOnline ? "Online since" : "Offline since",
          value: isOnline ? onlineSince : offlineSince,
        },
        { key: "Local IP", value: siteData.local_ip_address },
        { key: "Public IP", value: siteData.public_ip_address },
        { key: "Firmware", value: siteData.cl_version },
        { key: "Hardware", value: siteData.hardware_model },
        { key: "Uptime", value: siteData.uptime ? siteData.uptime.toFixed(0) + "%" : "Unknown" },
      ]}
    />
  );
}
